.section {
  padding: 76px 0;
  background: var(--color-primary-grey-000); /* PRIMARY_GREY_000 */
}

.grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 24px;
}
